// Export the Component Definition for use in Contentful Studio
export {GoFundMeDonationContentfulComponentDefinition} from './GoFundMeDonationContentfulDefinition';
export {default as default} from './GoFundMeDonation';
